import React, { useState } from "react";


const orders = []; 


const Orderpannel = () => {
  const [DateStatus, setDateStatus] = useState("Date Status");

  const [orderStatus, setOrderStatus] = useState("Order Status");
const [paymentStatus, setPaymentStatus] = useState("Payment Status");
const [fulfillmentStatus, setFulfillmentStatus] = useState("Fulfillment Status");
  return (
    <div className="container-fluid">
      <div className="row">


        {/* Content Section */}
        <div className=" p-1">

          <div className='bg-light p-3 rounded shadow-sm mb-3'>
          <h4>Your Orders</h4>
          <p className="text-muted">Track your orders</p>

          </div>

          
    <div className="py-3 d-flex flex-wrap justify-content-between align-items-center"> {/* Parent container */}
    <div className="d-flex flex-wrap gap-2 align-items-center">
        <select className="form-select form-select-sm w-auto"
          value={DateStatus}
          onChange={(e) => setDateStatus(e.target.value)}
        > 
          <option>Today</option>
          <option>Yesterday</option>
        </select>
        {/* Order Status Dropdown */}
        <select className="form-select form-select-sm w-auto"
          value={orderStatus}
          onChange={(e) => setOrderStatus(e.target.value)}
        >
          <option disabled>Order Status</option>
          <option>All</option>
          <option>Pending</option>
        </select>

        {/* Payment Status Dropdown */}
        <select className="form-select form-select-sm w-auto"
          value={paymentStatus}
          onChange={(e) => setPaymentStatus(e.target.value)}
        >
          <option disabled>Payment Status</option>
          <option>Paid</option>
          <option>Unpaid</option>
        </select>

        {/* Fulfillment Status Dropdown */}
        <select className="form-select form-select-sm w-auto"
          value={fulfillmentStatus}
          onChange={(e) => setFulfillmentStatus(e.target.value)}
        >
          <option disabled>Fulfillment Status</option>
          <option>Shipped</option>
          <option>Processing</option>
        </select>
      </div>

      <div className="d-flex flex-wrap gap-2">
                <button className="btn btn-primary btn-sm">Get Order Webhooks</button>
        <button className="btn btn-light btn-sm">
          <i className="bi bi-download"></i> Export CSV
        </button>
      </div>
    </div>
          <div className="table-responsive table-bordered">
          <table className="table">
          <thead className="small">
                <tr>
                  <th>Customer Name</th>
                  <th>Cart Date</th>
                  <th>Order ID</th>
                  <th>Order Details</th>
                  <th>Order Status</th>
                  <th>Payment Status</th>
                  <th>Fulfillment Status</th>
                </tr>
              </thead>
              <tbody>
                {orders.length === 0 ? (
            
                  <tr>
                    <td colSpan="7" className="text-center p-5">
                      <div className="d-flex flex-column align-items-center">
                        <h1 className='text-muted col-md-3 mt-2'><i class="bi bi-shop-window"></i></h1>
                        <p className="text-muted col-md-3 mt-2 small">
                          To see orders, please connect a catalog to Interakt and set the Auto Checkout Workflow live.
                        </p>
                        <button className="btn btn-success">Commerce Settings</button>
                      </div>
                    </td>
                  </tr>
                ) : (
                  orders.map((order, index) => (
                    <tr key={index}>
                      <td>{order.customerName}</td>
                      <td>{order.cartDate}</td>
                      <td>{order.orderId}</td>
                      <td>{order.orderDetails}</td>
                      <td>{order.orderStatus}</td>
                      <td>{order.paymentStatus}</td>
                      <td>{order.fulfillmentStatus}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>  )
}

export default Orderpannel